export const environment = {
  production: true,
  RECOGIDAS_API: '/api/1.0/',
  SECURITY_API: '/api/1.0/',
  HOST: 'https://docugest.acteco.es:8080',
  //HOST: 'http://ninive.alquy.com:8090',
  INITIAL_PERIOD_BETWEEN_DATES: 3,
  TOTAL_COUNT_HEADER: 'X-Total-Count',
  TIEMPO_RESTANTE: 10,
  ACTECO: 0,
  TIEMPO_TOTAL: 60
};
